exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tips[data-v-14311d8e]{background:#fdf6ec;color:#f59a23;padding:10px 5px;border-radius:8px;font-size:13px}", ""]);

// exports
